import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Delete from '@mui/icons-material/Delete';
import {cssCFButton} from 'module/CustomField/component/button/cssCFButton';
import {ArrowDropDown, ArrowDropUp} from '@mui/icons-material'
import {css} from '@emotion/react'

const cssRoot = css`
	display: flex;
	gap: 10px;
`
const cssButtonWrapper = css`
	display: flex;
	align-items: center;
`


interface Props {
	onClickDelete?: () => void;
	onClickUp?: () => void;
	onClickDown?: () => void;
	disabled: boolean
	wrap?: boolean
}

export function CFRowButtonsComponent({onClickDelete, onClickUp, onClickDown, disabled = false, wrap = false}: Props) {
	return <div css={cssRoot} style={wrap ? {flexWrap: 'wrap'} : undefined}>
		<div className={'CFRowDeleteButton'} css={cssButtonWrapper}>
			{onClickDelete &&
				<Tooltip title={'Zeile löschen'} disableInteractive>
					<Button
						css={cssCFButton.btn}
						size={'small'}
						onClick={onClickDelete}
						disabled={disabled}
					>
						<Delete/>
					</Button>
				</Tooltip>
			}
		</div>
		<div className={'CFRowMoveButton'} css={cssButtonWrapper}>
			{onClickUp && onClickDown && <div css={cssCFButton.stackWrapper}>
					<div>
						<Tooltip title={'Zeile hinaufschieben'} disableInteractive>
							<Button
								css={cssCFButton.stack}
								size={'small'}
								onClick={onClickUp}
								disabled={disabled}
							>
								<ArrowDropUp/>
							</Button>
						</Tooltip>
					</div>
					<div>
						<Tooltip title={'Zeile runterschieben'} disableInteractive>
							<Button
								css={cssCFButton.stack}
								size={'small'}
								onClick={onClickDown}
								disabled={disabled}
							>
								<ArrowDropDown/>
							</Button>
						</Tooltip>
					</div>
				</div>
				|| onClickUp &&
				<Tooltip title={'Zeile hinaufschieben'} disableInteractive>
					<Button
						css={cssCFButton.btn}
						size={'small'}
						onClick={onClickUp}
						disabled={disabled}
					>
						<ArrowDropUp/>
					</Button>
				</Tooltip>
				||
				onClickDown &&
				<Tooltip title={'Zeile runterschieben'} disableInteractive>
					<Button
						css={cssCFButton.btn}
						size={'small'}
						onClick={onClickDown}
						disabled={disabled}
					>
						<ArrowDropDown/>
					</Button>
				</Tooltip>
			}
		</div>
	</div>
}